<template>
  <div class="info">
    <el-form class="form"
             label-position="right"
             label-width="200px"
             :rules="rules"
             :model="ruleForm"
             ref="ruleForm">
      <!-- <el-form-item label="店铺名称：" prop="name">
                <p v-if="isnameUp && getUserInfo">{{ getUserInfo.shop_name }}<i @click="isnameUp = false" class="el-icon-edit-outline bj"></i></p>
                <p v-else style="display: flex; align-items: center">
                    <el-input style="width: 50%" clearable v-model="ruleForm.name"></el-input
                    ><el-button @click="nameSub" class="update" type="primary" :loading="isSaveLoading" size="medium">保存</el-button>
                    <el-button @click="cancelInput('ruleForm')" class="update" size="medium">取消</el-button>
                </p>
            </el-form-item>
            <el-form-item label="店铺LOGO：">
                <el-upload
                    style="display: inline-block"
                    action=""
                    :file-list="fileList"
                    list-type="picture-card"
                    :on-change="handleChange"
                    :auto-upload="false"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :limit="1"
                    :class="fileList.length == 1 ? 'mf' : ''"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item> -->
      <div v-if="getUserInfo && getUserInfo.merchant_type != 3">
        <el-form-item label="公司名称：">
          {{ getUserInfo.company_name }}
        </el-form-item>
        <el-form-item label="办公地址：">
          {{areaList.province_list[getUserInfo.address_provinces]}}
          {{areaList.city_list[getUserInfo.address_citys]}}
          {{areaList.county_list[getUserInfo.address_zones]}}
          <!--    {{ getUserInfo.address_managements }} -->
        </el-form-item>
        <el-form-item label="营业执照："
                      class="zz">
          <el-upload action="https://jsonplaceholder.typicode.com/posts/"
                     list-type="picture-card"
                     :file-list="fileList1"
                     :auto-upload="false">
            <!-- <el-link type="primary" :underline="false">修改</el-link> -->
            <div slot="file"
                 slot-scope="{ file }">
              <img style="width: 100%; height: 100%; background-size: 100% 100%"
                   class="el-upload-list__item-thumbnail"
                   :src="file.url"
                   alt="" />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="营业执照有效期：">
          <div v-if="getUserInfo.business_licenses_time_end == '' || getUserInfo.business_licenses_time_end == null">长期有效</div>
          <div v-else>
            {{ this.getRQ(getUserInfo.business_licenses_time_start) + " 至 " + this.getRQ(getUserInfo.business_licenses_time_end) }}
          </div>
        </el-form-item>
        <el-form-item label="运营联系人：">
          {{ getUserInfo.operator_name }}
        </el-form-item>
        <el-form-item label="运营人电话：">
          {{ getUserInfo.operator_cellphone }}
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="姓名："
                      v-if="getUserInfo">
          {{ getUserInfo.real_name }}
        </el-form-item>
        <el-form-item label="电话："
                      v-if="getUserInfo">
          {{ getUserInfo.cellphone }}
        </el-form-item>
        <el-form-item label="身份证号："
                      v-if="getUserInfo">
          {{ getUserInfo.identity_number }}
        </el-form-item>
        <el-form-item label="地址："
                      v-if="getUserInfo">

          {{areaList.province_list[getUserInfo.address_provinces]}}
          {{areaList.city_list[getUserInfo.address_citys]}}
          {{areaList.county_list[getUserInfo.address_zones]}}

        </el-form-item>
      </div>

      <el-form-item label="邮箱："
                    v-if="getUserInfo">
        {{ getUserInfo.email }}
      </el-form-item>
      <!-- <el-form-item label="微信收款账户：">
                <el-button type="primary" @click="createWeChat" size="medium">去开通</el-button>
            </el-form-item>
            <el-form-item label="支付宝收款账户：">
                <el-button type="primary" @click="createAlipay" size="medium">去开通</el-button>
            </el-form-item> -->
      <!-- <el-form-item v-if="getIsAllinUser == 0">
                <el-button type="primary" @click="openUrl" size="medium">注册通联</el-button>
            </el-form-item> -->
    </el-form>
    <!-- <el-form
            class="form"
            label-position="right"
            label-width="200px"
            :rules="vxRules"
            :model="vxRuleForm"
            ref="vxRuleForm"
        >
            <p class="zhanghu">提现账户</p>
            <el-form-item label="微信账户：" prop="vxVal">
                <p v-if="isVxNull">
                    {{ vxRuleForm.vxVal
                    }}<i
                        @click="isVxNull = false"
                        class="el-icon-edit-outline bj"
                    ></i>
                </p>
                <p v-else>
                    <el-input
                        :disabled="isVxNull"
                        style="width: 50%"
                        placeholder="请填写微信账户"
                        clearable
                        v-model="vxRuleForm.vxVal"
                    ></el-input>
                </p>
            </el-form-item>
            <el-form-item label="真实姓名：" prop="vxUser">
                <el-input
                    :disabled="isVxNull"
                    style="width: 50%"
                    placeholder="请填写真实姓名"
                    clearable
                    v-model="vxRuleForm.vxUser"
                ></el-input>
            </el-form-item>
            <el-form-item v-if="!isVxNull">
                <el-button
                    type="primary"
                    size="medium"
                    :loading="isWXLoading"
                    @click="submitForm('vxRuleForm')"
                    >提交</el-button
                >
                <el-button size="medium" @click="cancelInput('vxRuleForm')"
                    >取消</el-button
                >
            </el-form-item>
        </el-form>
        <el-form
            class="form"
            label-position="right"
            label-width="200px"
            :rules="zfbRules"
            :model="zfbRuleForm"
            ref="zfbRuleForm"
        >
            <el-form-item label="支付宝账户：" prop="zfbVal">
                <p v-if="isZfbNull">
                    {{ zfbRuleForm.zfbVal
                    }}<i
                        @click="isZfbNull = false"
                        class="el-icon-edit-outline bj"
                    ></i>
                </p>
                <p v-else>
                    <el-input
                        style="width: 50%"
                        clearable
                        v-model="zfbRuleForm.zfbVal"
                        placeholder="请填写支付宝账户"
                    ></el-input>
                </p>
            </el-form-item>
            <el-form-item label="真实姓名：" prop="zfbUser">
                <el-input
                    :disabled="isZfbNull"
                    style="width: 50%"
                    placeholder="请填写真实姓名"
                    clearable
                    v-model="zfbRuleForm.zfbUser"
                ></el-input>
            </el-form-item>
            <el-form-item v-if="!isZfbNull">
                <el-button
                    type="primary"
                    :loading="isAliLoading"
                    size="medium"
                    @click="submitForm('zfbRuleForm')"
                    >提交</el-button
                >
                <el-button size="medium" @click="cancelInput('zfbRuleForm')"
                    >取消</el-button
                >
            </el-form-item>
        </el-form> -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%"
           :src="dialogImageUrl"
           alt="" />
    </el-dialog>
    <CreateAlipayDia ref="refCreateAlipayDia"></CreateAlipayDia>
    <CreateWeChatDia ref="refCreateWeChatDia"></CreateWeChatDia>
  </div>
</template>



<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import CreateAlipayDia from "./createAlipayDia";
import CreateWeChatDia from "./createWeChatDia";
import help from "@/assets/js/common.js";
import dataList from '@/options/areaList'
export default {
  name: "info",
  trem: 0,
  data () {
    return {
      areaList: dataList,
      fileList: [],
      logoUrl: "",
      registerUrl: "",
      isSaveLoading: false,
      isAliLoading: false,
      isWXLoading: false,
      isVxNull: false,
      isZfbNull: false,
      userInfo: {},
      ruleForm: {
        name: "",
      },
      vxRuleForm: {
        vxVal: "",
        vxUser: "",
      },
      zfbRuleForm: {
        zfbVal: "",
        zfbUser: "",
      },
      isnameUp: true,
      fileList1: [],
      dialogImageUrl: "",
      dialogVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: "请输入店铺名称",
            trigger: "blur",
          },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
      },
      vxRules: {
        vxVal: [
          {
            required: true,
            message: "请输入微信账号",
            trigger: "blur",
          },
        ],
        vxUser: [
          {
            required: true,
            message: "请输入用户真实姓名",
            trigger: "blur",
          },
        ],
      },
      zfbRules: {
        zfbVal: [
          {
            required: true,
            message: "请输入支付宝账号",
            trigger: "blur",
          },
        ],
        zfbUser: [
          {
            required: true,
            message: "请输入用户真实姓名",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    CreateAlipayDia,
    CreateWeChatDia,
  },
  filters: {
    timeFormat (start, end) {
      let term = (end - start) / 3600 / 24;
      return term <= 0 ? "已到期" : Math.ceil(term) + "天";
    },
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
      getUserInfo: "getUserInfo",
      getAccountWx: "getAccountWx",
      getAccountAli: "getAccountAli",
      getIsAllinUser: "getIsAllinUser",
      getRegisterUrl: "getRegisterUrl",
    }),
  },
  created () {
    this.registerUrl = this.getRegisterUrl;
    // 获取帐户真实姓名
    this.getAccountApi({ token: this.getToken }).then((res) => {
      // console.log(res);
      if (res.data.code === 1) {
        if (res.data.data.count != 0) {
          this.setAccountWx(res.data.data.list[0].withdraw_wechat_name);
          this.setAccountAli(res.data.data.list[0].withdraw_ali_name);
        }
      }
      this.checkWithdraw();
    });

    // 获取用户信息
    this.getUserInfoPromise().then((res) => {
      // console.log(res);
      if (res.data.code === 1) {
        this.setUserInfo(res.data.data);
        this.fileList1 = [
          {
            url: res.data.data.business_licenses_imgs,
          },
        ];
        if (!!res.data.data.logos) {
          this.fileList = [{ url: res.data.data.logos }];
        }
      }
    });
    // console.log("info");
    // console.log(this.getUserInfo);
    if (this.getUserInfo) {
      this.vxRuleForm.vxVal = this.getUserInfo.withdraw_wechat;
      this.zfbRuleForm.zfbVal = this.getUserInfo.withdraw_ali;
    }

    this.vxRuleForm.vxUser = this.getAccountWx;
    this.zfbRuleForm.zfbUser = this.getAccountAli;
    this.userInfo = this.getUserInfo;
  },
  methods: {
    ...mapMutations({
      setUserInfo: "setUserInfo", //设置用户信息
      setAccountWx: "setAccountWx", //设置用户信息
      setAccountAli: "setAccountAli", //设置用户信息
    }),
    ...mapActions({
      getUserInfoApi: "loginModule/getUserInfoApi",
      upDataUserInfoForm: "loginModule/upDataUserInfoForm",
      setAccountInfo: "loginModule/setAccountInfo",
      getAccountApi: "loginModule/getAccountApi",
      uploadFile: "commodity/uploadFile",
    }),
    createWeChat () {
      this.$refs.refCreateWeChatDia.dialogVisible = true;
    },
    createAlipay () {
      this.$refs.refCreateAlipayDia.dialogVisible = true;
    },
    handleRemove (file, fileList) {
      this.fileList = this.fileList.filter((item) => {
        return item != file;
      });
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    updataLogo () {
      let opt = {
        token: this.getToken,
        logos: this.logoUrl,
        is_register: 2, //是否是注册修改，1-是注册修改，2-非注册修改
      };
      this.upDataUserInfoForm(opt).then((res) => {
        if (res.data.code === 1) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleChange (file, fileList) {
      var formdata = new FormData();
      formdata.append("formdata", file.raw);
      this.fileList = fileList;
      this.uploadFile(formdata).then((res) => {
        if (res.code == 1) {
          //  this.$message.success("上传成功！");
          this.logoUrl = res.data.formdata_details[0].urls;
          this.updataLogo();
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    openUrl () {
      window.open(this.registerUrl);
    },

    cancelInput (formName) {
      this.$refs[formName].resetFields();
      if (formName == "ruleForm") {
        this.isnameUp = true;
        this.ruleForm.name = this.getUserInfo.shop_name;
      } else if (formName == "vxRuleForm") {
        this.isVxNull = true;
        this.vxRuleForm.vxVal = this.getUserInfo.withdraw_wechat;
        this.vxRuleForm.vxUser = this.getAccountWx;
      } else if (formName == "zfbRuleForm") {
        this.isZfbNull = true;
        this.zfbRuleForm.zfbVal = this.getUserInfo.withdraw_ali;
        this.zfbRuleForm.zfbUser = this.getAccountAli;
      }
    },
    checkWithdraw () {
      if (this.getUserInfo) {
        if (this.getUserInfo.withdraw_wechat == null || this.getUserInfo.withdraw_wechat == "") {
          this.isVxNull = false;
        } else {
          this.isVxNull = true;
        }
        if (this.getUserInfo.withdraw_ali == null || this.getUserInfo.withdraw_ali == "") {
          this.isZfbNull = false;
        } else {
          this.isZfbNull = true;
        }
      }
    },

    nameSub () {
      if (this.ruleForm.name == null || this.ruleForm.name == "") {
        this.$message({
          message: "店铺名称不能为空",
          type: "error",
        });
        return;
      } else {
        this.isSaveLoading = true;
        let opt = {
          token: this.getToken,
          shop_name: this.ruleForm.name,
          is_register: 2, //是否是注册修改，1-是注册修改，2-非注册修改
        };
        this.upDataUserInfoForm(opt)
          .then((res) => {
            // console.log(res);
            if (res.data.code === 1) {
              this.userInfo.shop_name = this.ruleForm.name;
              this.setUserInfo(this.userInfo);
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.isnameUp = true;
            } else if (res.data.code === 2) {
              this.$message.warning("请重新登录");
              this.$router.push("/login");
            }
            this.isSaveLoading = false;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    nameReg (name) {
      return name.substring(0, 1) + new Array(name.length).join("*");
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let opt = {};
          if (formName == "vxRuleForm") {
            this.isWXLoading = true;
            opt = {
              account: this.vxRuleForm.vxVal.trim(),
              type: "wx",
              name: this.vxRuleForm.vxUser.trim(),
              token: this.getToken,
            };
          } else if (formName == "zfbRuleForm") {
            this.isAliLoading = true;
            opt = {
              account: this.zfbRuleForm.zfbVal.trim(),
              type: "ali",
              name: this.zfbRuleForm.zfbUser.trim(),
              token: this.getToken,
            };
          }
          this.setAccountInfo(opt)
            .then((res) => {
              // console.log(res);
              if (res.data.code === 1) {
                this.$message.success("提交成功！");
                this.getUserInfoPromise()
                  .then((res) => {
                    if (opt.type == "wx") {
                      this.isVxNull = true;

                      this.setAccountWx(this.vxRuleForm.vxUser);
                    } else if (opt.type == "ali") {
                      this.isZfbNull = true;

                      this.setAccountAli(this.zfbRuleForm.zfbUser);
                    }
                    this.setUserInfo(res.data.data);
                    this.isAliLoading = false;
                    this.isWXLoading = false;
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          return false;
        }
      });
    },
    getUserInfoPromise () {
      return new Promise((resolve, reject) => {
        let opt = {
          token: this.getToken,
          reviewer_status: 1, //审核状态(固定写1)
        };
        this.getUserInfoApi(opt)
          .then((res) => {
            // console.log(res);
            if (res) {
              resolve(res);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    getRQ (val) {
      return help.getRQ(val);
    },
  },
};
</script>
<style lang='scss' scoped>
.zz {
  ::v-deep .el-upload--picture-card {
    height: 0;
    display: none;
  }
}

.zhanghu {
  margin: 30px 0;
  font-size: 24px;
}
.bj {
  font-size: 30px;
  position: relative;
  top: 6px;
  cursor: pointer;
  margin-left: 20px;
}
.update {
  margin-left: 20px;
}
.info {
  width: 50%;
  margin: 0 auto;
  margin-top: 30px;
}

li.el-upload-list__item > div {
  height: 100%;
}
.mf {
  ::v-deep .el-upload--picture-card {
    display: none !important;
  }
}
</style>